import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=4a9478c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9478c0"]])

export default __exports__